import { GenericRule } from '../../../../../../../utils/genericValidator.util';
import { AvailabilityEnum } from '../../../../../../products/ProductTypes';
import { OfflineOrderProduct } from '../../OfflineOrderProduct';

export class OfflineOrderProductStockError extends Error {
  constructor() {
    super('insufficient stock');
    this.name = 'OfflineOrderProductStockError';
  }
}

export class ValidateStockOrderProductRule implements GenericRule<OfflineOrderProduct> {
  validateOrThrow(orderProduct: OfflineOrderProduct) {
    if (
      [AvailabilityEnum.INFINITE_PRE_ORDER, AvailabilityEnum.EMPTY].includes(
        orderProduct.availability,
      )
    ) {
      return;
    }

    const allStocksValid =
      orderProduct.availability === AvailabilityEnum.FUTURE_STOCK
        ? this.futureStockValid(orderProduct)
        : this.readyForDeliveryValid(orderProduct);

    if (!allStocksValid) {
      throw new OfflineOrderProductStockError();
    }
  }

  private futureStockValid(orderProduct: OfflineOrderProduct) {
    return orderProduct.grid.every(
      (gridItem) => gridItem.quantity <= (gridItem.futureStock?.availableAmount || 0),
    );
  }

  private readyForDeliveryValid(orderProduct: OfflineOrderProduct) {
    return orderProduct.grid.every(
      (gridItem) => gridItem.quantity <= (gridItem.stock?.availableAmount || 0),
    );
  }
}
